import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const HowItWorks = () => {
  const { ref: titleRef, inView: titleInView } = useScrollAnimation();
  const { ref: stepsRef, inView: stepsInView } = useScrollAnimation({ threshold: 0.2 });

  const steps = [
    {
      iconSrc: '/icons/download-setup.svg',
      title: 'Download & Setup',
      description: 'Create a secure profile by answering a few questions.'
    },
    {
      iconSrc: '/icons/sync-rhythm.svg',
      title: 'Sync Your Rhythm',
      description: 'Integrate all aspects of health without compromise to faith-based wellness.'
    },
    {
      iconSrc: '/icons/wellness.svg',
      title: 'Wellness at Every Stage',
      description: 'Learn about your health at every stage: menstruation, fertility, pregnancy, and menopause.'
    },
    {
      iconSrc: '/icons/connect.svg',
      title: 'Connect With The Right Resource',
      description: 'Doctors, Islamic scholars, and peer support—all in one place.'
    }
  ];

  return (
    <section id="how-it-works" className="how-it-works-section">
      <Container>
        <h2 
          ref={titleRef}
          className={`how-it-works-title animate-on-scroll ${titleInView ? 'visible' : ''}`}
        >
          How It Works
        </h2>
        <Row 
          ref={stepsRef}
          className={`g-4 justify-content-center stagger-container ${stepsInView ? 'visible' : ''}`}
        >
          {steps.map((step, index) => (
            <Col xs={12} sm={6} lg={3} key={index}>
              <div className="step-card">
                <div className="step-icon-wrapper">
                  <div className="step-icon">
                    <img 
                      src={step.iconSrc} 
                      alt={step.title}
                      className="step-icon-img"
                      loading="lazy"
                    />
                  </div>
                </div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default HowItWorks;